// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"5dd7dfa8","419":"b7ac0fd5","692":"c300990f","774":"0f1dee56","835":"597e1881"}[chunkId] + ".chunk.js";
};